export const isMdOrLess = window.innerWidth <= 991;
